import React, { useState, useEffect } from 'react';
import { reservaService } from '../../services/reservaService';
import PublicNavbar from '../publico/PublicNavbar';

const ClientDashboard = () => {
  const [reservas, setReservas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
  fetchMisReservas();
  }, []);

  const fetchMisReservas = async () => {
    try {
      const response = await reservaService.getMisReservas();
      setReservas(response.data);
    } catch (error) {
      setError('Error al cargar tus reservas');
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-indigo-50 to-green-50">
        <PublicNavbar />
        <div className="flex items-center justify-center h-64">
          <div className="text-center">
            <svg className="animate-spin h-10 w-10 text-indigo-500 mx-auto" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" /><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" /></svg>
            <p className="mt-2 text-lg text-gray-700 font-semibold">Cargando dashboard...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 to-green-50">
      <PublicNavbar />
      <div className="max-w-4xl mx-auto py-8 px-2 sm:px-4">
        <div className="bg-white/90 rounded-2xl shadow-2xl border border-indigo-100 px-4 sm:px-8 py-6 mb-8">
          <h1 className="text-2xl sm:text-3xl font-bold text-indigo-700 mb-6 flex items-center gap-2">
            <svg className="w-7 h-7 text-green-500" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M8 17l4 4 4-4m-4-5v9" /></svg>
            Mis Reservas
          </h1>
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded mb-4 flex items-center gap-2">
              <svg className="w-5 h-5 text-red-400" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M18.364 5.636l-12.728 12.728M5.636 5.636l12.728 12.728" /></svg>
              {error}
            </div>
          )}
          {Array.isArray(reservas) && reservas.length > 0 ? (
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200 text-sm sm:text-base">
                <thead className="bg-indigo-50">
                  <tr>
                    <th className="px-4 py-2 text-left font-semibold text-gray-600 uppercase">Fecha</th>
                    <th className="px-4 py-2 text-left font-semibold text-gray-600 uppercase">Hora</th>
                    <th className="px-4 py-2 text-left font-semibold text-gray-600 uppercase">Cancha</th>
                    <th className="px-4 py-2 text-left font-semibold text-gray-600 uppercase">Establecimiento</th>
                    <th className="px-4 py-2 text-left font-semibold text-gray-600 uppercase">Estado</th>
                    <th className="px-4 py-2 text-left font-semibold text-gray-600 uppercase">Total</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100">
                  {reservas.map((reserva) => {
                    // Formatear fecha ISO a DD/MM/YYYY
                    let fechaFormateada = reserva.fecha;
                    if (fechaFormateada && fechaFormateada.includes('T')) {
                      // formato: YYYY-MM-DDTHH:mm:ss.sssZ
                      const [fechaSolo] = fechaFormateada.split('T');
                      const [y, m, d] = fechaSolo.split('-');
                      fechaFormateada = `${d}/${m}/${y}`;
                    } else if (fechaFormateada && fechaFormateada.includes('-')) {
                      const [y, m, d] = fechaFormateada.split('-');
                      fechaFormateada = `${d}/${m}/${y}`;
                    }
                    // Mostrar total solo si existe, es numérico y no negativo
                    let total = reserva.precio_total;
                    if (total !== null && total !== undefined && !isNaN(Number(total)) && Number(total) > 0) {
                      total = `S/ ${Number(total).toFixed(2)}`;
                    } else {
                      total = '';
                    }
                    return (
                      <tr key={reserva.id} className="hover:bg-green-50 transition">
                        <td className="px-4 py-2 whitespace-nowrap font-medium text-gray-800">{fechaFormateada}</td>
                        <td className="px-4 py-2 whitespace-nowrap">{reserva.hora_inicio} - {reserva.hora_fin}</td>
                        <td className="px-4 py-2 whitespace-nowrap">{reserva.cancha?.nombre || reserva.cancha_id}</td>
                        <td className="px-4 py-2 whitespace-nowrap">{reserva.establecimiento?.nombre_negocio || reserva.establecimiento_id}</td>
                        <td className="px-4 py-2 whitespace-nowrap capitalize">
                          <span className={`inline-block px-2 py-1 rounded text-xs font-semibold ${reserva.estado === 'pagada' ? 'bg-green-100 text-green-700' : reserva.estado === 'pendiente' ? 'bg-yellow-100 text-yellow-700' : 'bg-gray-100 text-gray-600'}`}>{reserva.estado}</span>
                        </td>
                        <td className="px-4 py-2 whitespace-nowrap font-semibold text-green-700">{total}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-gray-500 text-center py-8">
              <svg className="w-12 h-12 mx-auto mb-2 text-gray-300" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M9 17v-2a4 4 0 014-4h2a4 4 0 014 4v2m-6-6a4 4 0 11-8 0 4 4 0 018 0z" /></svg>
              No tienes reservas registradas.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ClientDashboard;
